import { Helmet } from 'react-helmet';
import { siteConfig } from '../config.js';
import FacilitiesSectionA from '../components/FacilitiesSectionA.js';
import Header from '../components/Header.js';
import PreFooter from '../components/PreFooter';
import Footer from '../components/Footer';
import VirtualProgramming from '../components/ServicesSectionD.js';

export default function FacilitiesPage() {
  return (
    <>
      <Helmet>
        <title>FAQ's | {siteConfig.title}</title>
        <meta name="description" content={siteConfig.metaDescription} />
      </Helmet>

      <Header config={siteConfig} />
        <FacilitiesSectionA />
        <VirtualProgramming />
      <PreFooter />
      <Footer />
    </>
  );
}
